import { create } from "zustand";

// LQC-2957 - CPI from GET /ReferenceData/CPI/{index}, one answer per index and start
// date for the session (current CPI is keyed without a date).

export enum CpiStatus {
  Loading = "Loading",
  Loaded = "Loaded",
  Error = "Error",
}

export interface ICpiResult {
  status: CpiStatus;
  cpi: number | null;
}

type State = {
  cpiByKey: Record<string, ICpiResult>;
};

type Actions = {
  setCpi: (key: string, result: ICpiResult) => void;
  clearCpi: () => void;
};

const cpiStore = create<State & Actions>((set) => ({
  cpiByKey: {},
  setCpi: (key, result) =>
    set((state) => ({ cpiByKey: { ...state.cpiByKey, [key]: result } })),
  clearCpi: () => set({ cpiByKey: {} }),
}));

export default cpiStore;
